<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('addTopic' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setCreateTopicDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-text-field v-model="getTopic.name" :rules="topicNameRules" :label="$i18n.t('title')" class="pa-0 ma-0"/>
                    <v-radio-group v-model="radio">
                        <v-radio :value="true" @change="setAtLast">
                            <template slot="label">
                                {{ $i18n.t('addLast') + '(' + $i18n.t('topic') + ' ' + (getTopics.length+1) + ')' }}
                            </template>
                        </v-radio>
                        <v-radio :value="false" @change="setAtPosition">
                            <template slot="label">
                                {{ $i18n.t('addMiddle1') }}
                                <v-col cols=1>
                                    <v-select :items="getTopics.map(topic => topic.position)" v-model="position" @change="setAtPosition" :disabled="radio" style="width: 70px"/>
                                </v-col>
                                {{ $i18n.t('addMiddle2') }}
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            radio: true,
            position: 1,
            topicNameRules: [
                v => !!v || i18n.t('noTopicName'),
                v => !v || v.length <= 255 || i18n.t('longTopicName'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('createTopic')
        },
        setAtLast(){
            this.getTopic.position = this.getTopics.length //+1 cuando no haya tema 0
        },
        setAtPosition(){
            this.getTopic.position = this.position
        }
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getCreateTopicDialog',
            'getTopic',
            'getTopics',
        ]),
    },

    watch: {
        getCreateTopicDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
